<template>
  <div v-if="inventoryBlocks && inventoryBlocks.length > 1">
    <h4 class="title">Выберите квоту</h4>
    <div class="row">
      <div class="col-lg-12">
        <ul class="nav nav-pills nav-pills-rose text-center" data-tabs="tabs" style="margin-bottom: 15px">
          <router-link v-for="item in inventoryBlocks" :key="item.id"
                       :class="{active : String(inventoryBlock) === String(item.id)}" active-class="fake"
                       :to="{name: $route.name, query: queryGenerator({inventory_block: item.id})}"
                       tag="li">
            <a>{{item.hotel.name}}: {{ item.name }}</a>
          </router-link>
        </ul>
        <span v-if="!inventoryBlock">Выберите одну из квот.</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'InventoryBlockSelect',
  computed: {
    ...mapGetters(
      {
        inventoryBlocks: 'inventoryBlocks',
      },
    ),
    inventoryBlock() {
      if (this.inventoryBlocks.find(item => Number(item.id) === Number(this.$route.query.inventory_block))) {
        return this.$route.query.inventory_block;
      }
      return null;
    },
  },
  created() {
    if (!this.$route.query.inventory_block) {
      this.$router.push({ name: this.$route.name, query: { inventory_block: this.inventoryBlocks[0].id } })
        .catch(err => {});
    } else {
      this.$emit('inventoryBlockChanged', this.inventoryBlock);
    }
  },
  updated() {
    if (!this.$route.query.inventory_block && this.$route.name === 'booking') {
      this.$router.push({ name: this.$route.name, query: { inventory_block: this.inventoryBlocks[0].id } })
        .catch(err => {});
    }
  },
  methods: {
    queryGenerator(value) {
      const query = {};
      Object.assign(query, this.$route.query, value);
      return query;
    },
    queryClear(key) {
      const query = {};
      Object.assign(query, this.$route.query);
      delete query[key];
      return query;
    },
  },
  watch: {
    inventoryBlock() {
      this.$emit('inventoryBlockChanged', this.inventoryBlock);
    },
  },
};
</script>
